import React, { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { CardImage } from "@/components/CardImage";
import { toast } from "sonner";

const OUTCOMES = { contestata: [["riprendi", "Fai riprendere lo scambio"], ["annulla", "Annulla lo scambio e libera le carte"]], other: [["chiusa", "Chiudi la contestazione"]] };

function DisputeCard({ d, onDone }) {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const resolve = async (outcome) => {
    setBusy(true);
    try { await api.post(`/admin/disputes/${d.id}/resolve`, { outcome, reason }); toast.success("Contestazione gestita."); onDone(); }
    catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-lg border border-[#2A3655] bg-[#141B2D] p-3" data-testid="admin-dispute">
      <p className="text-sm font-semibold text-[#F59E0B]">{d.category_label} <span className="font-normal text-[#94A3B8]">· scambio {d.proposal_id.slice(0, 8)} ({d.trade_status}) · {d.participant_usernames.map((u) => `@${u}`).join(" ↔ ")}</span></p>
      <p className="mt-1 text-xs text-[#94A3B8]">Aperta da {d.opened_by_username ? `@${d.opened_by_username}` : "sistema"} il {new Date(d.created_at).toLocaleString("it-IT")}</p>
      <p className="mt-1 text-sm text-[#CBD5E1]">{d.description}</p>
      {d.photos?.length > 0 && <div className="mt-2 flex flex-wrap gap-1">{d.photos.map((ph) => <div key={ph} className="w-16"><CardImage path={ph} className="w-16" /></div>)}</div>}
      <Textarea value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Motivazione (obbligatoria, registrata e inviata alle parti)" data-testid="admin-dispute-reason" className="mt-2 bg-[#0B1020] border-[#2A3655]" />
      {d.trade_status === "contestata" && <p className="mt-1 text-[11px] text-[#64748B]">Se lo scambio ha un conguaglio già pagato, l'eventuale rimborso va gestito a parte dal pannello Stripe.</p>}
      <div className="mt-2 flex flex-wrap gap-2">
        {(OUTCOMES[d.trade_status] || OUTCOMES.other).map(([k, l]) => <Button key={k} size="sm" onClick={() => resolve(k)} disabled={busy || reason.trim().length < 10} data-testid={`admin-dispute-${k}`} className="bg-[#7C3AED] hover:bg-[#6D28D9]">{l}</Button>)}
      </div>
    </div>
  );
}

export function DisputesTab() {
  const [items, setItems] = useState([]);
  const load = () => { api.get("/admin/disputes", { params: { status: "aperta" } }).then((r) => setItems(r.data)).catch(() => {}); };
  useEffect(() => { load(); }, []);
  return (
    <div className="space-y-2" data-testid="admin-disputes">
      {items.length === 0 ? <p className="text-sm text-[#94A3B8]">Nessuna contestazione aperta.</p> : items.map((d) => <DisputeCard key={d.id} d={d} onDone={load} />)}
    </div>
  );
}

export function FeedbackModeration({ report, onDone }) {
  const [reason, setReason] = useState("");
  const [fb, setFb] = useState(null);
  useEffect(() => { api.get(`/admin/feedback/${report.target_id}`).then((r) => setFb(r.data)).catch(() => {}); }, [report.target_id]);
  const moderate = async (action) => {
    try { await api.post(`/admin/feedback/${report.target_id}/moderate`, { action, reason }); toast.success(action === "hide" ? "Recensione nascosta." : "Recensione mantenuta visibile."); onDone(); }
    catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div className="mt-2 space-y-2" data-testid="admin-feedback-moderation">
      {fb && <p className="rounded border border-[#2A3655] bg-[#0B1020] p-2 text-xs text-[#CBD5E1]">Voto {fb.rating}/5 (non modificabile) · "{fb.comment || "senza commento"}"{fb.hidden ? " · attualmente nascosta" : ""}</p>}
      <Textarea value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Motivazione della moderazione (obbligatoria)" data-testid="admin-feedback-reason" className="bg-[#0B1020] border-[#2A3655]" />
      <div className="flex gap-2">
        <Button size="sm" disabled={reason.trim().length < 10} onClick={() => moderate("hide")} data-testid="admin-feedback-hide" className="bg-[#7C3AED] hover:bg-[#6D28D9]">Nascondi recensione</Button>
        <Button size="sm" disabled={reason.trim().length < 10} onClick={() => moderate("restore")} data-testid="admin-feedback-keep" variant="outline" className="border-[#2A3655] bg-transparent text-[#F8FAFC]">{fb?.hidden ? "Ripristina" : "Mantieni visibile"}</Button>
      </div>
    </div>
  );
}
